import { render } from "./EditSentNoteGlobal.vue?vue&type=template&id=263770dd&ts=true"
import script from "./EditSentNoteGlobal.vue?vue&type=script&lang=ts"
export * from "./EditSentNoteGlobal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__